export default __webpack_public_path__ + "static/media/coin-ethereum-white.69cfd833.svg";